export interface OrderConfirmModel {
    type: OrderConfirmModel.TypeEnum;
}
export namespace OrderConfirmModel {
    export type TypeEnum = 'order_close' | 'transfer_trailer';
    export const TypeEnum = {
        Close: 'order_close' as TypeEnum,
        Transfer: 'transfer_trailer' as TypeEnum
    };
}
